const json = {
    "login":"đăng nhập"
}

export default json;